import { Rating } from '@app/components/molecules/rating';
import { accommodationStaticSlice, useAppSelector } from '@app/state';

import { ReviewsHeaderProps } from './reviews-header.props';

export const ReviewsHeader = (props: ReviewsHeaderProps) => {
    const { ratingAverage, ratingCount, ratingDescription } = useAppSelector(
        accommodationStaticSlice.selectors.selectReviewsData,
    );

    return ratingAverage && ratingCount && ratingDescription ? (
        <Rating
            ratingAverage={ratingAverage}
            ratingCount={ratingCount}
            ratingDescription={ratingDescription}
            flexDirection={'row'}
            justifyContent={'start'}
            textAlign={'left'}
            labelProps={{
                fontSize: 'lg',
            }}
            {...props}
        />
    ) : null;
};
